module.exports = __webpack_public_path__ + "cartilla2.png?d863b087a1a61bef2d17c3ab9422254a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cartilla2.png
// module id = 671
// module chunks = 0 2 7 8 9 10